<template>
  <div>
    <drag
      class="drag"
      @dragstart="handleDragstart"
      @dragend="handleDragend"
      :transfer-data="{ visiteurID: visiteur.visiteurID, placePupitreActif: visiteur.placePupitre, menuStelected: visiteur.menuSelected, reponseCobrowsing: visiteur.reponseCobrowsing }"
    >
    <!-- <v-toolbar dark dense :color="color"> -->
    <v-toolbar
      dark
      dense
      class="grey lighten-1"
      :class="{newMessage : visiteurLastMessage}"
    >
      <wz-avatar
        v-if="visiteur.network"
        :src="visiteur.profile_pic"
        :username="visiteur.visiteurName"
        size="38px"
      >
      </wz-avatar>
      <wz-avatar
        v-else-if="istypingVisiteur"
        :isTyping="istypingVisiteur"
        :username="'#' + visiteur.visiteurID"
        size="38px"
        chip
        class="istypingListAttente"
      ></wz-avatar>
      <wz-avatar
        v-else-if="!istypingVisiteur && visiteurLastMessage"
        :username="'#' + visiteur.visiteurID"
        size="38px"
        lastMessage
      ></wz-avatar>
      <wz-avatar
        v-else
        :username="'#' + visiteur.visiteurID"
        size="38px"
      ></wz-avatar>
      
      <v-flex ellipsis ml-2>
        <div class="ellipsis">{{nameVisiteur}}</div>
        <div class="ellipsis">{{visiteur.lastMessage}}</div>
      </v-flex>
      <v-spacer></v-spacer>
      <wz-visiteur-timer :timeStart="visiteur.timeStampArrive" @updateSeuil="colorAttente"></wz-visiteur-timer>
      <v-menu bottom right>
        <v-btn icon slot="activator" dark>
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list dense>
          <v-list-tile
            v-for="item in itemsMenu"
            :disabled="item.disabled"
            :key="item.title"
            @click="item.disabled ? '' : menuAction(item.nameAction)"
          >
            <v-list-tile-action><v-icon>{{ item.icon }}</v-icon></v-list-tile-action>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <div  v-if="!visiteur.connexion" class="clientAttenteOffline error"></div>

    <!-- dialog transfere chat -->
    <v-dialog v-model="dialogTransfereChat" fullscreen transition="dialog-bottom-transition" :overlay="false">
      <v-card>
        <v-toolbar dark class="primary">
          <v-menu bottom right>
            <v-btn icon @click.native="dialogTransfereChat = false" dark>
              <v-icon>close</v-icon>
            </v-btn>
            <v-list dense>
              <v-list-tile
                v-for="item in itemsMenu"
                :disabled="item.disabled"
                :key="item.title"
                @click="item.disabled ? '' : menuAction(item.nameAction)"
              >
                <v-list-tile-action><v-icon>{{ item.icon }}</v-icon></v-list-tile-action>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-card>
    </v-dialog>
      <div  v-if="!visiteur.connexion" class="clientAttenteOffline error"></div>

      <!-- dialog fin chat -->
      <wz-dialog-close-chat
        @fermeDialogCloseChat="fermeDialogCloseChat"
        :datasVisiteur="visiteur"
        :dialogCloseChat="dialogCloseChat"
      >
      </wz-dialog-close-chat>

      <!-- dialog trasfer -->
      <wz-dialog-transfert-chat
        ref="dialogTransfert"
        :datasVisiteur="visiteur"
      >
      </wz-dialog-transfert-chat>

    </drag>
  </div>
</template>

<script>
import _ from 'lodash'
import _watcheebox from '../watcheebox/watcheebox.js'
import {mapGetters, mapState} from 'vuex'
import { Drag } from 'vue-drag-drop'
export default {
  components: {Drag},
  props: {
    visiteur: {
      type: Object,
      required: true
    },
    pupitreData: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      itemsMenu: [],
      selectedAgent: {
        'id': '',
        'name': '',
        'status': ''
      },
      dialogTransfereChat: false,
      color: 'light-blue',
      checkForMotif: false,
      dialogCloseChat: false,
      formulaireSatisfaction: false,
      clotureChat: false
    }
  },

  mounted () {
    if (this.$store.state._User.entKey === '9c44184c124fda32ac19523ff93d2488') {
      this.checkForMotif = true
    }

    this.itemsMenu = [
      {
        title: _.upperFirst(this.$t('toOpen')),
        icon: 'arrow_upward',
        // nameAction: 'retireChat',
        nameAction: 'openChat',
        disabled: false
      },
      {
        title: _.upperFirst(this.$t('close')),
        icon: 'clear',
        // nameAction: 'retireChat',
        nameAction: 'closeChat',
        disabled: false
      },
      {
        title: _.upperFirst(this.$t('toTransfer')),
        icon: 'forward',
        nameAction: 'transferer',
        disabled: this.checkSocialVisiteur()
      },
      {
        title: _.upperFirst(this.$t('banish')),
        icon: 'block',
        nameAction: 'bannChat',
        disabled: false
      }
    ]
  },

  methods: {
    // ----------------------------------------------------------------------------
    // Actions du menu deroulant de droite de la fenetre de chat
    // en changeant la class (bigChat/smallChat) de afenetre de chat
    // ----------------------------------------------------------------------------
    menuAction (value) {
      if (value === 'closeChat') {
        // retire le visiteur de la liste d'attente
        this.fermeChat()
      } else if (value === 'openChat') {
        // prend la place d'un autre visiteur dans le pupitre
        // console.log('pupitreData', this.pupitreData[0].view)
        // console.log('pupitreViewStatus', this.pupitreViewStatus)
        this.modifPlacePupitre({
          dataDrop: {
            visiteurID: this.visiteur.visiteurID,
            placePupitreActif: this.visiteur.placePupitre,
            reponseCobrowsing: this.visiteur.reponseCobrowsing,
            menuStelected: this.visiteur.menuSelected
          },
          // attention si la place est vide il faut bien envoyer quelque chose comme 'undefined'
          statusView: this.pupitreData[0].view.viewStatus ? this.pupitreData[0].view.viewStatus : false,
          place: 1, // prend la place 1 du pupitre
          idVisiteurPlace: this.pupitreData[0].view.viewStatus ? this.pupitreData[0].view.visiteurDatas.visiteurID : 'undefined',
          menuSelectedPlace: this.pupitreData[0].view.viewStatus ? this.pupitreData[0].view.visiteurDatas.menuSelected : 'undefined',
          reponseCobrowsingPlace: this.pupitreData[0].view.viewStatus ? this.pupitreData[0].view.visiteurDatas.responseCobrowsing : 'undefined'
        })
        // this.$emit('supVisiteurFile', this.visiteur.visiteurID)
      } else if (value === 'transferer') {
        console.log('transferVisiteur', this.visiteur.visiteurID)
        this.$refs.dialogTransfert.open()
      } else if (value === 'bannChat') {
        console.log('bannir le visiteur')
      }
    },

    // -----------------------------------
    // change la place du pupitre du visiteur en attente
    // avec une place visible
    // -----------------------------------
    modifPlacePupitre (data) {
      this.$store.commit('_StoreWatcheeBox/CHANGE_PLACE_PUPITRE_VISITEUR', data)
      // this.dataEchangePlace = null
    },

    handleDragstart () {
      console.log('drag chat')
      this.$store.commit('_StoreWatcheeBox/CHANGE_DRAG_CHAT', true)
    },

    handleDragend () {
      console.log('stop drag chat')
      this.$store.commit('_StoreWatcheeBox/CHANGE_DRAG_CHAT', false)
    },

    // ----------------------------------------------------------------------------
    // ouvre la dialogBox 'fermeChat' sur le btn dans la div de deconnexion .offlineVisiteur
    // quant le visiteur n'est plus la
    // ----------------------------------------------------------------------------
    fermeChat () {
      // ouvre la dialogBox
      this.dialogCloseChat = true
    },

    // ----------------------------------------------------------------------------
    // ferme le chat
    // avec option envois formulaire de satisfaction
    // et cloture de chat
    // c'est un message de type 4
    // ----------------------------------------------------------------------------
    fermeDialogCloseChat (data) {
      // console.log('fermeDialogCloseChat', data)
      this.dialogCloseChat = data.dialogCloseChat
    },

    // ----------------------------------------------------------------------------
    // Actions de transfere de chat vers un autre agent dispo
    // ----------------------------------------------------------------------------
    transferChat () {
      console.log('transferChat', this.visiteur)
      // si un agent est selectionné dans la liste
      if (this.selectedAgent.id !== '') {
        // il faut recuperer toutes les données visiteur pour le transfere
        var datasVisiteurSelect = {
          'socketID': this.visiteur.socketID,
          'visiteurID': this.visiteur.visiteurID,
          'visiteurKey': this.visiteur.roomName
        }
        var mySocketID = this.WATCHEEBOX_STATE.mySocketID
        _watcheebox.SendTransfertVisitor(
          {
            'selectedAgent': this.selectedAgent,
            'datasSelectedVisiteur': datasVisiteurSelect,
            'agentsArray': this.agentsArray,
            'socket': this.$socket,
            'myAgentID': this.$store.state._User.id,
            'mySocketID': mySocketID,
            'agentSenderName': this.fullName
          }
        )
      } else {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'Selectionnez un agent dans la liste avant de transferer ce visiteur', context: 'warning' })
      }
    },

    // ----------------------------------------------------------------------------
    // Annule le transfert
    // ----------------------------------------------------------------------------
    transferChatAnnuler () {
      // console.log('this.selectedAgente', this.selectedAgent)
      // console.log('this.agentsArray', this.agentsArray)
      // console.log('this.WATCHEEBOX_STATE.mySocketID', this.WATCHEEBOX_STATE.mySocketID)
      var mySocketID = this.WATCHEEBOX_STATE.mySocketID
      _watcheebox.AnnulTransfertVisitor(
        {
          'selectedAgent': this.selectedAgent,
          // 'agentsArray': this.agentsArray,
          'socket': this.$socket,
          'mySocketID': mySocketID,
          'agentSenderName': this.fullName
        }
      )
      this.dialogTransfereChat = false // affiche la dialogueBox
      // this.$store.commit('_StoreWatcheeBox/SET_TRANSFERE_STATUS', '')
      this.$store.commit('_StoreWatcheeBox/SOCKET_VISITOR_TRANSFERT', {
        status: '',
        emission: true,
        messageDatas: ''
      })
    },

    checkSocialVisiteur () {
      if (this.visiteur.network) {
        return true
      } else {
        return false
      }
    },

    colorAttente (seuil) {
      let colors = ['light-blue', 'teal', 'lime', 'orange', 'red', 'deep-purple']
      this.color = colors[seuil]
    }
  },

  watch: {
    'visiteur.visiteurID': function () {
      this.dialogTransfereChat = false
    },

    formulaireSatisfaction (v) {
      this.$cookie.set('wz-satisfaction-survey', v, { expires: '1Y' })
    },

    clotureChat (v) {
      this.$cookie.set('wz-closing-chat', v, { expires: '1Y' })
    }
  },

  computed: {
    ...mapState('_StoreWatcheeBox', ['agentsArray', 'listeChatAgent', 'pupitreViewStatus']),
    ...mapGetters('_User', ['user', 'fullName']),
    ...mapGetters('_StoreWatcheeBox', ['WATCHEEBOX_STATE']),

    hasMotif () {
      let thisVisit = _.find(this.$store.state._StoreWatcheeBox.listeAllVisiteurs, {
        visiteurID: this.visiteur.visiteurID
      })
      return thisVisit ? thisVisit.motif : false
    },

    // regarde si ce visiteur ecrit un message (istyping)
    istypingVisiteur () {
      var typing = _.find(this.visiteur.histoChat, {'isTyping': true, 'auteur': 'Visiteur'})
      if (typing) {
        return true
      } else {
        return null
      }
    },

    // regarde si ce visiteur n'est pas en chat avec un autre agent
    dejaEnChat () {
      var data = _.find(this.listeChatAgent, [0, this.visiteur.visiteurID])
      if (data) {
        let userFound = this.$store.getters['_User/getUserById'](data[3])
        return {'sessionID': data[0], 'agentID': data[3], 'agentName': userFound.USR_FIRST_NAME + ' ' + userFound.USR_LAST_NAME}
      } else {
        return null
      }
    },

    // affiche le nom du visiteur si dispo
    nameVisiteur () {
      if (this.visiteur.visiteurName) {
        return this.visiteur.visiteurName
      } else {
        return this.visiteur.visiteurID
      }
    },

    // affiche le dernier message chat du visiteur
    visiteurLastMessage () {
      // return this.datasVisiteur.firstChat
      if (this.visiteur.lastMessage && this.visiteur.lastMessage !== null) {
        return this.visiteur.lastMessage
      } else {
        return null
      }
    }
  }
}
</script>
<style>
.istypingListAttente .badgeTyping{margin-left: 30px;}
</style>



// WEBPACK FOOTER //
// src/components/watcheebox/WzVisiteurAttente.vue